<template lang="html">
  <section>
    <div class="floating flex column">
      <a class="container-icon" :href="`tel:${$t('contacto.phone')}`" @click="eventGA('Button-phone')">
        <img src="/static/img/icon-flo-phone.svg" alt="icon floating to phone" />
      </a>
      <a class="container-icon" :href="`mailto:${$t('contacto.email')}`" @click="eventGA('Button-email')">
        <img src="/static/img/icon-flo-mail.svg" alt="icon floating to mail" />
      </a>
      <router-link v-if="!popup || $route.name !== 'home'" class="container-icon" :to="'/' + $i18n.locale + '/' + $t('enlaces.vehiculo_electrico')">
        <img src="/static/img/vehiculo-electrico/electric-vehicle-blue.svg" alt="icon vehiculo eléctrico" />
      </router-link>
    </div>

  </section>
</template>

<script lang="js">
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'floating-icons',
  props: [],
  data() {
    return {}
  },
  methods: {
    ...mapActions({
      changePopup: 'changePopup'
    }),
    openMoreInfo: function () {
      this.changePopup(true)
    },

  },
  computed: {
    ...mapGetters({
      popup: 'getPopup'
    })
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/parts/floating-icons.vue